import { useConfig } from "./api";
import { XMAS_PRODUCT, XMAS_GIRL, NY_PRODUCT, NY_GIRL, PHOTO } from "./content";

export const useXmasImage = (handle) => {
  const { season } = useSeason();
  if (!season) return null;
  return (season === "newyear" ? NY_PRODUCT : XMAS_PRODUCT)[handle] || null;
};
export const useGirlPhoto = () => {
  const { season } = useSeason();
  return season === "newyear" ? NY_GIRL : season ? XMAS_GIRL : PHOTO.girl;
};

const XMAS_IMG = "/img/88f68e11e051e869a556d93e1afe6d357d2d19f661e3e9da34d9a84c5ca3.webp";
const NY_IMG = "/img/e05af7dfbe3d35d05cc861edfe3c713c2e3293f7e356cdfe6b999ddb3366.webp";
export const GIFT_BOX_IMG = "/img/1915ab2efddbd7f3d0e7dc1b0fb75a71bc867e8c9755bcac40f44caa50f0.webp";

export const GIFT_SETS = [
  { size: 2, handles: ["shimmering-body-oil-primus", "day-cream-for-face-and-neck"] },
  { size: 3, handles: ["face-and-neck-cream-primus", "day-face-serum-nutritive-primus", "spray-body-oil-primus"] },
  { size: 5, handles: ["oil-shower-gel-bellecare-natural", "body-milk-balm-bellecare", "hair-serum-bellecare", "hair-shampoo-bellecare", "hair-oil-for-split-ends"] },
];

const override = () => {
  const q = new URLSearchParams(window.location.search).get("season");
  if (q) sessionStorage.setItem("ajs_season", q);
  return sessionStorage.getItem("ajs_season");
};

export const useSeason = () => {
  const { data } = useConfig();
  const o = override();
  const season = o === "off" ? null : o || data?.season || null;
  const tiers = data?.gift_tiers || [];
  return {
    season, active: !!season, tiers,
    maxPct: Math.max(0, ...tiers.map((t) => t.pct)),
    image: season === "newyear" ? NY_IMG : XMAS_IMG,
    tierFor: (n) => [...tiers].reverse().find((t) => n >= t.size) || null,
  };
};
